import Badge from "~/components/shared/Badge";
import TeamPrivacyConstants from "~/constants/TeamPrivacyConstants";
import { PureComponent } from "react";
import { createFragmentContainer, graphql } from "react-relay";

type Props = {
  team: any;
};

class TeamLabels extends PureComponent<Props> {
  render() {
    if (this.props.team.privacy === TeamPrivacyConstants.SECRET) {
      return (
        <div className="ml-1 flex">
          <Badge outline={true} className="font-normal">
            Secret
          </Badge>
        </div>
      );
    }
    return null;
  }
}

export default createFragmentContainer(TeamLabels, {
  team: graphql`
    fragment Labels_team on Team {
      privacy
    }
  `,
});
